class Module06Testimonial {
    constructor() {
        const cache = {};
        const AUTOPLAY_DELAY = 5000;
        let autoplayIntervals = new Map();

        const initFunc = () => {
            initCache();
            registerEvents();
            initAutoplay();
            initMobileSlider();
        };

        const initCache = () => {
            cache.testimonialModules = document.querySelectorAll(".module-06-testimonial");
        };

        const registerEvents = () => {
            cache.testimonialModules.forEach((module) => {
                const cards = module.querySelectorAll(".testimonial-card");
                const contents = module.querySelectorAll(".testimonial-content");

                cards.forEach((card, index) => {
                    card.addEventListener("click", () => {
                        activateElement(index, cards, contents);
                    });
                });

                activateElement(0, cards, contents);
            });
        };

        const initAutoplay = () => {
            cache.testimonialModules.forEach((module) => {
                const cards = module.querySelectorAll(".testimonial-card");
                const contents = module.querySelectorAll(".testimonial-content");
                let currentIndex = 0;

                const nextTestimonial = () => {
                    currentIndex = (currentIndex + 1) % cards.length;
                    activateElement(currentIndex, cards, contents);
                };

                const interval = setInterval(nextTestimonial, AUTOPLAY_DELAY);
                autoplayIntervals.set(module, interval);
            });
        };

        const activateElement = (index, cards, contents) => {
            // Désactiver tous les éléments
            cards.forEach((card) => card.classList.remove("active"));
            contents.forEach((content) => {
                content.classList.remove("active");
            });

            // Activer les éléments sélectionnés
            if (cards[index]) cards[index].classList.add("active");
            if (contents[index]) {
                contents[index].classList.add("active");
            }
        };

        const initMobileSlider = () => {
            cache.testimonialModules.forEach((module) => {
                const slider = module.querySelector('.testimonial-slider');
                const dots = module.querySelector('.testimonial-dots');
                const dotsButtons = module.querySelectorAll('.dot');
                const items = module.querySelectorAll('.testimonial-item');
                let currentSlide = 0;
                let touchStartX = 0;
                let touchEndX = 0;

                // Fonction pour changer de slide
                const goToSlide = (index) => {
                    currentSlide = index;
                    slider.style.transform = `translateX(-${index * 100}%)`;
                    
                    // Mettre à jour les dots
                    dotsButtons.forEach((dot, i) => {
                        dot.classList.toggle('active', i === index);
                    });
                };

                // Gestion des dots
                dotsButtons.forEach((dot, index) => {
                    dot.addEventListener('click', () => {
                        if (autoplayIntervals.has(module)) {
                            clearInterval(autoplayIntervals.get(module));
                        }
                        goToSlide(index);
                    });
                });

                // Gestion du swipe
                slider.addEventListener('touchstart', (e) => {
                    touchStartX = e.touches[0].clientX;
                });

                slider.addEventListener('touchend', (e) => {
                    touchEndX = e.changedTouches[0].clientX;
                    const diff = touchStartX - touchEndX;

                    if (Math.abs(diff) > 50) { // Seuil minimum pour le swipe
                        if (diff > 0 && currentSlide < items.length - 1) {
                            goToSlide(currentSlide + 1);
                        } else if (diff < 0 && currentSlide > 0) {
                            goToSlide(currentSlide - 1);
                        }
                    }
                });

                // Autoplay pour mobile
                const startMobileAutoplay = () => {
                    const interval = setInterval(() => {
                        const nextSlide = (currentSlide + 1) % items.length;
                        goToSlide(nextSlide);
                    }, AUTOPLAY_DELAY);
                    autoplayIntervals.set(module, interval);
                };

                startMobileAutoplay();

                // Arrêter l'autoplay au toucher
                slider.addEventListener('touchstart', () => {
                    if (autoplayIntervals.has(module)) {
                        clearInterval(autoplayIntervals.get(module));
                    }
                });

                // Reprendre l'autoplay après le toucher
                slider.addEventListener('touchend', () => {
                    startMobileAutoplay();
                });
            });
        };


        initFunc();
    }
}

export { Module06Testimonial };